import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { v4 as uuid } from "uuid";
import { Order } from "../../../domain/entities/order/Order";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const orderRepo = OrderRepositoryImpl.getInstance();

const DEFAULT_ORDER = { countryCode: "", items: [] };

const useGetOrder = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data, isError, refetch } = useQuery(
    {
      queryKey: ["orderData", auth],
      queryFn: async () => {
        return await orderRepo.getOrder(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  useEffect(() => {
    if (isError) {
      (async () => {
        const orderId = uuid();
        await orderRepo.placeOrder(orderId, auth, apiUrl);
      })();
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isError]);

  return { isLoading, order: (data || DEFAULT_ORDER) as Order, refetchOrder: refetch };
};

export { useGetOrder };
